import { Box, styled, Typography } from "@material-ui/core";
import {
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../_lib/epocus-palette";
import { SettingsCard } from "./settings-card";

const Row = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 12,
});

const Avatar = styled(Box)({
  width: 44,
  height: 44,
  flexShrink: 0,
  borderRadius: "50%",
  backgroundColor: EPOCUS_PRIMARY,
  color: EPOCUS_WHITE,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: rem(15),
});

const Name = styled(Typography)({
  fontSize: rem(16),
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
});

const MetaRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 6,
  marginTop: 3,
});

const ProgramName = styled(Typography)({
  fontSize: rem(13),
  color: EPOCUS_TEXT_SECONDARY,
});

const initials = (parts: readonly (string | null | undefined)[]): string =>
  parts
    .map((part) => part?.trim().charAt(0) ?? "")
    .join("")
    .toUpperCase();

export const IdentityHeader: FC<{
  firstName?: string | null;
  lastName?: string | null;
  programName?: string | null;
}> = ({ firstName, lastName, programName }) => {
  const fullName = [firstName, lastName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ");
  const monogram = initials([firstName, lastName]);

  return (
    <SettingsCard>
      <Row>
        {monogram && <Avatar aria-hidden>{monogram}</Avatar>}
        <Box>
          {fullName && <Name>{fullName}</Name>}
          <MetaRow>
            {programName && <ProgramName>{programName}</ProgramName>}
          </MetaRow>
        </Box>
      </Row>
    </SettingsCard>
  );
};
